import { Tables } from "@/integrations/supabase/types";

export type DocumentFolder = Tables<"document_folders"> & {
  owner?: {
    id: string;
    full_name: string | null;
    email: string | null;
  };
};

export interface DocumentFolderWithCount extends DocumentFolder {
  document_count?: number;
}

export interface CreateDocumentFolderInput {
  name: string;
  color?: string;
  icon?: string;
  position?: number;
}

export interface UpdateDocumentFolderInput {
  name?: string;
  color?: string;
  icon?: string;
  position?: number;
}

export const DEFAULT_FOLDER_COLORS = [
  "#4E9CFF", // Spark Blue - Primary brand color
  "#FF4DB8", // Magenta Beam - Secondary brand color
  "#FFBB33", // Amber Glow - Accent brand color
  "#3B82F6", // Primary Blue Hover
  "#7f84ea", // Button Purple - Brand button color
  "#D946EF", // Secondary Dark Purple
  "#2563EB", // Primary Dark Blue
  "#E73BAE", // Secondary Hover Pink
  "#F59E0B", // Accent Hover Orange
  "#28406F", // Logo Navy - Brand logo color
] as const;

export const FOLDER_ICONS = [
  "folder",
  "folder-open",
  "briefcase",
  "archive",
  "file-box",
  "book",
  "library",
  "layers",
] as const;

export type FolderColor = typeof DEFAULT_FOLDER_COLORS[number];
export type FolderIcon = typeof FOLDER_ICONS[number];

